import { useNavigate, useLocation } from 'react-router-dom'
import { Tabs } from 'antd'

export function AgentManageTabs() {
  const navigate = useNavigate()
  const location = useLocation()
  const activeKey = location.pathname.includes('/manage/agents/skills') ? 'skills' : 'agents'

  return (
    <Tabs
      type="card"
      size="small"
      className="agent-manage-tabs"
      activeKey={activeKey}
      onChange={(key) => navigate(key === 'skills' ? '/manage/agents/skills' : '/manage/agents')}
      items={[
        { key: 'agents', label: '智能体管理' },
        { key: 'skills', label: 'Skill 库' },
      ]}
    />
  )
}
